import { render, staticRenderFns } from "./VipNavigation.vue?vue&type=template&id=1c83c7fc&scoped=true&"
import script from "./VipNavigation.vue?vue&type=script&lang=js&"
export * from "./VipNavigation.vue?vue&type=script&lang=js&"
import style0 from "./VipNavigation.vue?vue&type=style&index=0&id=1c83c7fc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c83c7fc",
  null
  
)

export default component.exports